var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppButton',{class:{
		'sound-toggle': true,
		'is-muted': ! _vm.useAudio,
	},attrs:{"name":_vm.useAudio ? 'mute' : 'unmute',"location":"main","icon":"sound","is-plain":""},on:{"click":_vm.toggleAudio}},[_vm._v(" "+_vm._s(_vm.$l10n( _vm.useAudio ? 'mute' : 'unmute' ))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }